<script>
	import Bubble from '$lib/Components/Layout/Bubble/Bubble.svelte';
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';
	import Reviews from '$lib/PageSections/Reviews/Reviews.svelte';
	import twentyFiveBroadStreet from './images/25-Broad-Street-NYC-02-e1551123709825.jpg';
	import insertCorner from './images/IW-CS-window-replacement-alternative-04.jpg';
	import hotelCourtYard from './images/LP-Embassy-Suites-Orlando-image-03-e1549933044696.png';
	import hotelInteriorWindow from './images/LP-Embassy-Suites-Orlando-image-05-e1549933100103.jpg';
</script>

<Section>
	<p>
		Architects, general contractors, general managers, building owners, etc.
		should know that we offer a pilot program to test out our large storm
		windows in your commercial buildings. Perfect for hotels with noise
		problems, government building projects, and apartment buildings undergoing
		renovation.
	</p>
	<p>
		Noise can lead to lost revenue via customer dissatisfaction and decreased
		worker productivity.
	</p>
	<p>
		Historic properties may have energy and money literally going out the
		window.
	</p>
	<Image
		src={twentyFiveBroadStreet}
		alt="Indow inserts being installed in large commercial windows at 25 Broad Street in New York City."
	/>
	<p>
		Window inserts bring immediate, sustainable relief—cutting noise, stopping
		drafts, and reducing energy loss the moment they are installed. Best of all,
		installation takes minutes and requires zero construction with no disruption
		to guests, workers, or tenants.
	</p>
	<p>
		Place an order on just a single room to see if your issue is resolved before
		moving forward with your project. No obligation, no minimums, just relief.
	</p>
	<Bubble backgroundColor="grey-light" class="mb-10">
		<p class="text-lg font-bold text-indow-grey-dark! uppercase">Benefits</p>
		<ul>
			<li><p>It's just a test, no commitment to a future order</p></li>
			<li><p>Small investment that will pay itself back</p></li>
			<li>
				<p>
					The sooner you resolve these issues, the sooner your occupancy rate
					goes up, employees and tenants are happier
				</p>
			</li>
			<li>
				<p>Installation of large storm windows is instant once they arrive</p>
			</li>
			<li>
				<p>Small part of budget now to plan into budget for next fiscal year</p>
			</li>
		</ul>
	</Bubble>
	<h2>How Our Pilot Program Works in Commercial Buildings</h2>
	<h3>Contact us, your window experts.</h3>
	<p>
		Get a free consultation. We’ll figure out what your issue is, the best grade
		type, and room to test: usually the worst offender.
	</p>
	<p>
		Next, <a href="/about-indow/how-to-order"
			>you enter your window measurements</a
		> into our proprietary measurement software which automatically checks your measurements.
	</p>

	<h3>Inserts are sent to you.</h3>
	<p>
		You test as long as you want, however you want. We can help with a plan that
		works for your commercial building.
	</p>
	<p>
		We stay in contact to make sure things are going well. But we won’t be
		annoying.
	</p>

	<Image
		src={insertCorner}
		alt="closeup of Indow window insert, thermal window replacement alternative"
	/>
	<h2>Ways to Test Inserts in Commercial Windows</h2>
	<p>
		You can use acoustical equipment, but one guest can be so much more
		sensitive than the next—their feedback is invaluable. Some hotels offer
		incentives to guests for feedback, such as a free breakfast. That’s up to
		you.
	</p>
	<p>
		Frank, the General Manager of Embassy Suites Orlando, had all the managers
		on his team take turns sleeping in their pilot room to test the noise coming
		through their commercial windows.
	</p>
	<h2>If Large Storm Windows Don’t Work Out</h2>
	<p>
		Because the project fell through, or the budget wasn’t approved, or the
		window inserts just didn’t work for you—then that’s it. We really appreciate
		you trying them out! We appreciate any feedback you have and if you run into
		anyone for whom our window inserts would work out, let us know.
	</p>

	<Image src={hotelInteriorWindow} />
</Section>
<Section>
	<h2>Testimonials</h2>
	<Image src={hotelCourtYard} />
	<Bubble class="mx-auto my-16!">
		<span
			class="
     -mb-2 -ml-6 w-full text-left text-3xl font-normal text-indow-grey
     not-italic
   ">❝</span
		>
		<blockquote class="mb-0 text-xl font-bold italic">
			You came in and, I want to say, within one day installed 167 windows. I
			was amazed by that. I thought it would take several days to do. I would
			say the number of complaints we get from outside noise has probably
			dropped 70-80%
		</blockquote>
		<span
			class="
     -mt-2 -mr-6 w-full text-right text-3xl font-normal text-indow-grey
     not-italic
   ">❞</span
		>

		<p class="mb-0 w-full text-right font-extrabold text-indow-blue!">
			<span class="text-indow-grey-dark">–</span> Frank,
			<span class="text-indow-blue">General Manager Embassy Suites Orlando</span
			>
		</p>
	</Bubble>
	<Bubble class="mx-auto my-16!">
		<span
			class="
     -mb-2 -ml-6 w-full text-left text-3xl font-normal text-indow-grey
     not-italic
   ">❝</span
		>
		<blockquote class="mb-0 text-xl font-bold italic">
			Acoustic Grade Indow window inserts seemed to be the only solution to
			insulate the train noise. We realized that if we fixed our window problem
			we could lease the space for market rates… instead of leasing far below
			market. The return on the investment has been outstanding and we like
			happy tenants!
		</blockquote>
		<span
			class="
     -mt-2 -mr-6 w-full text-right text-3xl font-normal text-indow-grey
     not-italic
   ">❞</span
		>

		<p class="mb-0 w-full text-right font-extrabold text-indow-blue!">
			<span class="text-indow-grey-dark">–</span> Mike Larkin,
			<a
				class="text-indow-blue"
				href="/resources/case-studies/office-soundproofing"
				>Elliott Associates Broker and Property Manager</a
			>
		</p>
	</Bubble>

	<p>
		<a class="text-indow-blue" href="/resources/case-studies"
			>Read more case studies.
		</a>
	</p>
</Section>
<Reviews />
<GetAFreeEstimate />
